import { createContext, useContext, useState } from 'react';

type CarrySettingsSaveContextValue = {
  isPending: boolean;
  setSaveButtonPending: (isPending: boolean) => void;
};

const CarrySettingsSaveContext = createContext<CarrySettingsSaveContextValue>({
  isPending: false,
  setSaveButtonPending: () => {},
});

export const CarrySettingsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isPending, setIsPending] = useState(false);
  return (
    <CarrySettingsSaveContext.Provider
      value={{ isPending, setSaveButtonPending: setIsPending }}
    >
      {children}
    </CarrySettingsSaveContext.Provider>
  );
};

export const useCarrySettingsContext = () =>
  useContext(CarrySettingsSaveContext);
